import { NgModule, SecurityContext } from '@angular/core';
import { CommonModule, NgClass, NgForOf, NgIf } from '@angular/common';
import { MarkdownModule } from 'ngx-markdown';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AppLayoutModule } from './layout/app.layout.module';
import { ChatComponent } from './features/chat/chat.component';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { SessionInterceptor } from './core/interceptors/session.interceptor';
import { ErrorInterceptor } from './core/interceptors/error.interceptor';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { VirtualScrollerModule } from 'primeng/virtualscroller';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { MultiSelectModule } from 'primeng/multiselect';
import { SubscriptionsComponent } from './features/subscriptions/subscriptions.component';
import { KeyFilterModule } from 'primeng/keyfilter';
import { ButtonGlobotComponent } from './shared/components/button-globot/button-globot.component';
import { provideLottieOptions } from 'ngx-lottie';
import player from 'lottie-web';
import { WidgetConfigComponent } from './features/widget-config/widget-config.component';
import { CardModule } from 'primeng/card';
import { SafePipe } from './shared/pipes/safe.pipe';
import { ChartModule } from 'primeng/chart';

import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';

@NgModule({
  declarations: [
    AppComponent,
    ChatComponent,
    SubscriptionsComponent,
    WidgetConfigComponent,
    SafePipe,
  ],
  imports: [
    AppRoutingModule,
    AppLayoutModule,
    InputTextModule,
    ButtonModule,
    RippleModule,
    NgForOf,
    FormsModule,
    ReactiveFormsModule,
    NgIf,
    ProgressSpinnerModule,
    VirtualScrollerModule,
    NgClass,
    ToastModule,
    MultiSelectModule,
    KeyFilterModule,
    ButtonGlobotComponent,
    CardModule,
    CheckboxModule,
    DropdownModule,
    CommonModule,
    ChartModule,
    MarkdownModule.forRoot({
      sanitize: SecurityContext.HTML,
    }),
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: SessionInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    MessageService,
    provideLottieOptions({ player: () => player }),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
